// =====================================
//
//   FAQ Controller
//   Author: Wayne
//   createtime: 2016 / 08 / 29
//
// =====================================

window.InifECMobileApp.controller("FAQController", ['$scope', '$state', '$timeout', '$rootScope', '$stateParams', 'FAQService',
	function($scope, $state, $timeout, $rootScope, $stateParams, FAQService) {

        var getFAQClasslist = function() {

            if($scope.isLoading) {
                return;
            }

            $scope.isLoading = true;

            $scope.mainFAQList = FAQService.getMainFAQList();

            if($scope.mainFAQList.length > 0) {
                $scope.isLoading = false;
                return;
            }

            FAQService.getFAQClasslist().then(function(result) {
                if (result && result.mainFAQClassIDs && result.mainFAQClassIDs.length){

                    var mainFAQClassIDs = result.mainFAQClassIDs;
                    var mainFAQClassIDMap = result.mainFAQClassIDMap;

                    for(var i = 0; i < mainFAQClassIDs.length; i++) {

                        var mainid = mainFAQClassIDs[i];
                        var mainclass = mainFAQClassIDMap[mainid];

                        if(!mainclass || mainclass.length == 0) {
                            continue;
                        }

                        var subFAQClassList = mainclass.subFAQClassList;
                        var subFAQClassMap = mainclass.subFAQClassMap;
                        var subFAQList = [];
                        let FAQList = []


                        for(var j = 0; j < subFAQClassList.length; j++) {

                            var subid = subFAQClassList[j];
                            var subclass = subFAQClassMap[subid];

                            if(!subclass || subclass.length == 0) {
                                continue;
                            }

                            subclass.isShowMenu = false;
                            subclass.faqList = [];
                            FAQService.getSubClassFAQlist(subid).then(function(result) {
                                if(result && result.length) {
                                    for (let k = 0; k < result.length; k++) {
                                        result[k].isShow = false
                                        FAQList.push(result[k])
                                        
                                    }
                                }
                            })
                            subFAQList.push(subclass);
                        }

                        $scope.mainFAQList.push({
                            title: mainclass.title,
                            mainFAQClassID: mainclass.mainFAQClassID,
                            subFAQList: subFAQList,
                            FAQList: FAQList,
                        })
                    }

                    FAQService.setMainFAQList($scope.mainFAQList);

                } else {

                    $scope.isError = true;

                }

                $scope.isLoading = false;

            }, function(error) {

                $scope.isError = true;
                $scope.isLoading = false;
            });
        };

        var getSubClassFAQlist = function(subfaq) {

            if($scope.isLoading) {
                return;
            }

            $scope.isLoading = true;

            FAQService.getSubClassFAQlist(subfaq.subFAQClassID).then(function(result) {
                if(result && result.length) {
                    subfaq.faqList = result; 
                } else {
                    $scope.isError = true;
                }

                $scope.isLoading = false;

            }, function(error) {

                $scope.isError = true;
                $scope.isLoading = false;
            });
        };

        var toggleMenu = function(faq){
            faq.isShow = !faq.isShow;

            getSubClassFAQlist(faq);            
        };

        // --------------------------------
        // focus search input
        // --------------------------------
        var searchFocus = function() {

            $scope.isFocus = true;
        }

        // --------------------------------
        // blur search input
        // --------------------------------
        var searchBlur = function() {

            $scope.isFocus = false;
        }

        // --------------------------------
        // 搜尋問題
        // --------------------------------
        var searchFAQ = function(event) {

            if(event) {
                event.preventDefault();
            }

            if($scope.form.keyword) {
                $state.go(window.STATES.SEARCH_FAQ, {
                    keyword: $scope.form.keyword
                });

                $scope.form.keyword = '';
            }
        }

        var init = function() {
             getFAQClasslist();   
             
        };

	    //==========================
        //  Events
        //==========================

        //==========================
        //  Members
        //==========================
        $scope.form = {
            keyword: '',
        };

        $scope.mainFAQList = [];
        $scope.mainfaqid;
        $scope.subfaqid;

        $scope.isError = false;
        $scope.isLoading = false;
        $scope.isFocus = false;

        //==========================
        //  Methods
        //==========================
        $scope.toggleMenu = toggleMenu;
        $scope.searchFocus = searchFocus;
        $scope.searchBlur = searchBlur;
        $scope.searchFAQ = searchFAQ;
        
        //==========================
        //  Init
        //==========================
        init();
	}
]);